<div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12" *ngFor="let item of data">
        <div class="card bg-secondary text-white m-1" style="border: none;">
            <div class="card-body">
              <h5 class="card-title">{{item.titulo}}</h5>
              <p class="card-text">{{item.descripcion}}</p>
              <button class="btn btn-primary btn-block" (click)="show(item)">{{item.button}}</button>
            </div>
          </div>
    </div>    
</div>


<app-modal-loading [show]="modal_loading"></app-modal-loading>
<app-anuncio-listados *ngIf="modal_imagelistado" ></app-anuncio-listados>

